export * as campusEnums from './campus'
export * as hiddenFormParamEnums from './hiddenFormParam'
export * as personaEnums from './persona'
export * as profileEnums from './profile'
export * as programEnums from './program'
export * as queryStringParamEnums from './queryStringParam'

export enum formRedirectEnums {
  CONFIRMATION_OLD = '/confirmation',
  CONFIRMATION_NEW = '/confirmation/ready',
}
